module.exports = __webpack_public_path__ + "static/media/paper-clip.c3230be8.svg";